import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  Box,
} from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { AppBarProps } from '@material-ui/core';
import { connect } from 'react-redux';
import AccountPopover from './AccountPopover';
import MenuIcon from '../icons/Menu';

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
  user?: any;
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: '#087bf6',
    boxShadow: 'none',
    color: theme.palette.primary.contrastText,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
}));

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const { onSidebarMobileOpen, user, ...other } = props;

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <div style={{ flexGrow: 1 }}>
          <Hidden lgUp>
            <IconButton color="inherit" onClick={onSidebarMobileOpen}>
              <MenuIcon fontSize="small" />
            </IconButton>
          </Hidden>
          <Hidden lgDown>
            <RouterLink to="/admin">
              <img src="/static/images/kontigo.png" alt="logo" width={150} />
            </RouterLink>
          </Hidden>
        </div>
        <Box mr={2}>
          <Typography>{user?.name}</Typography>
          <Typography variant="subtitle2">{user?.role?.name}</Typography>
        </Box>
        <AccountPopover />
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

const mapStateToProps = (state) => ({ user: state.auth.user });

export default connect(mapStateToProps, {})(DashboardNavbar);
